import { useNavigate } from "react-router-dom";
import { Button } from "UI/Button/Button";
import Layout from "layout/Layout";
import styles from "./Moc.module.scss";

const Moc = () => {
  const navigate = useNavigate();

  const handleCBU = () => {
    navigate("/cbu/mock");
  };

  const handleQRPay = () => {
    navigate("/qrpay/mock");
  };

  const handleQRBol = () => {
    navigate("/qrbol/mock");
  };

  const handleSuccess = () => {
    navigate("/success/mock");
  };

  const handleCanceled = () => {
    navigate("/canceled/mock?type=canceled");
  };

  return (
    <Layout headerText="Mock Pages" headerStep="" currentStep={0}>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <h1 className={styles.title}>Test Pages</h1>

          <div className={styles.buttons}>
            <Button onClick={handleCBU} variant="yellow">
              CBU Page
            </Button>

            <Button onClick={handleQRPay} variant="yellow">
              QR Pay Page
            </Button>

            <Button onClick={handleQRBol} variant="yellow">
              QR Bolivia Page
            </Button>

            <Button onClick={handleSuccess} variant="yellow">
              Success Page
            </Button>

            <Button onClick={handleCanceled} variant="yellow">
              Canceled Page
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Moc;

